import { render, staticRenderFns } from "./ApprovalRequestCard.vue?vue&type=template&id=319069b2&"
import script from "./ApprovalRequestCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequestCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRequestCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VChip})
